var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],class:{ favorite: true, active: _vm.active},attrs:{"icon":"icon-heart","circle":_vm.circle},on:{"click":function($event){_vm.user ? _vm.toggleFavorite() : _vm.$router.push({ name: 'Welcome' })}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e1898a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Core/Favorite.vue
// module id = 1194
// module chunks = 1 3 6 7 8